import React, { useState } from 'react';
import { Accordion, Col, Container, Row } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { GrFacebookOption } from 'react-icons/gr';
import { FaPinterestP, FaTiktok, FaInstagram } from 'react-icons/fa';
import { IoIosArrowUp } from 'react-icons/io';
import { base_url, postHeader } from '../../Helper/request';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { tabData } from '../../Reducer/metaReducer';
import ReCAPTCHA from "react-google-recaptcha";
import { LiveChatWidget, EventHandlerPayload } from '@livechat/widget-react'

const Footer = () => {
  const location = useLocation()
  function handleNewEvent() {
  }
  const dispatch = useDispatch();
  const storeLocation = useSelector(
    (state) => state.persistedReducer.home.store_locations
  );
  const metaText = useSelector(
    (state) => state?.persistedReducer?.meta?.meta?.content
  );
  const faqMetaText = useSelector(
    (state) => state?.persistedReducer?.meta?.faqMeta
  );
  const [visible, setVisible] = useState(false);
  const history = useNavigate();
  const [newslettername, setNewslettername] = useState('');
  const [newsletteremail, setNewsletteremail] = useState('');
  const [loader, setLoader] = useState(false);
  const [captchaStatus, setcaptchaStatus] = useState(true);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 500) {
      setVisible(true);
    } else if (scrolled <= 500) {
      setVisible(false);
    }
  };
  const tabHandle = (val) => {
    dispatch(tabData(val));
    window.scrollTo({
      top: 400,
      behavior: 'smooth',
    });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  window.addEventListener('scroll', toggleVisible);

  const hndlnewsletter = (e) => {
    e.preventDefault();
    const data = {
      name: newslettername,
      email: newsletteremail,
    };
    if (window?.klaviyo) {
      window.klaviyo.push(['identify', {
        'email': newsletteremail,
        'name': newslettername,
        'news_Letter': "News Letter"
      }])
    };
    setLoader(true);
    // window.woopra.track("newsletter", {
    //   email: newsletteremail,
    // });
    axios
      .post(base_url + '/common/subscribe_newsletter', data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setLoader(false);
          setNewslettername('');
          setNewsletteremail('');
          return toast(res.data.message, '', 'success');
        } else {
          setLoader(false);
          return toast(res.data.message, '', 'error');
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
      });
  };
  const capthcaHandle = (res) => {
    if (res) {
      setcaptchaStatus(false);
    }
  };
  return (
    <>
      {
        // metaText && metaText !== null && <div className='metaSection mb-4 mt-3'>
        //   <Container>

        //     <div dangerouslySetInnerHTML={{ __html: metaText }} />
        //   </Container>
        // </div>
      }
      {
        //   location.pathname!=="/" &&
        //  faqMetaText && faqMetaText.length > 0 && <div className='faqMetaElement customerservicecontainer mb-5 mt-3'>
        //   <Container>
        //   <Accordion>
        //           {
        //               faqMetaText.length > 0 && faqMetaText?.map((e, i) => (
        //                   <Accordion.Item eventKey={e?.id} key={i}>
        //                       <Accordion.Header>{e?.title}</Accordion.Header>
        //                       <Accordion.Body>{e?.value}</Accordion.Body>
        //                   </Accordion.Item>
        //               ))
        //           }

        //       </Accordion>

        //   </Container>
        //   </div>
      }

      <footer className="footer">
        {/* <Container className='d-none'>
                    <Row>
                        <Col md={3} lg={3}>
                            <div className='footer_box'>
                                <h1 className='text-white'>CUSTOMER SUPPORT</h1>
                                <ul className='footer_link'>
                                    <li><Link to='/contact-us'>Contact Us</Link></li>
                                    <li><Link to='#'>Returns & Exchanges</Link></li>
                                    <li><Link to='#'>Shipping</Link></li>
                                    <li><Link to='#'>FAQ</Link></li>
                                </ul>
                            </div>
                        </Col>
                        <Col md={3} lg={3}>
                            <div className='footer_box'>
                                <h1 className='text-white'>CONNECT WITH US</h1>
                                <ul className='footer_link'>
                                    <li><Link to='https://www.instagram.com/weddingdaydiamonds/' target='_blank'>Instagram</Link></li>
                                    <li><Link to='https://www.facebook.com/WeddingDayDiamondsMN/' target='_blank'>Facebook</Link></li>
                                    <li><Link to='https://www.tiktok.com/@weddingdaydiamonds' target='_blank'>TikTok</Link></li>
                                    <li><Link to='https://br.pinterest.com/weddingdaydiamonds/' target='_blank'>Pinterest</Link></li>
                                    <li><Link to='https://www.youtube.com/c/weddingdaydiamonds' target='_blank'>YouTube</Link></li>
                                </ul>
                            </div>
                        </Col>
                        <Col md={3} lg={3}>
                            <div className='footer_box'>
                                <h1 className='text-white'>FIND A SHOWROOM</h1>
                                <ul className='footer_link'>
                                    <li><Link to='#'>Minnesota</Link></li>
                                    {storeLocation?.map(stores=>
                                       <li className='ps-3'><Link to='#'>{stores.location}</Link></li>
                                    )}
                                </ul>
                                <ul className='footer_link mt-2'>
                                    <li><Link to='#'>Virtual Appointment</Link></li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container> */}

        <Container fluid>
          <Row>
            <Col md={12} lg={9} className="p-0">
              <div className="footer_row">
                <div className="footer_box">
                  <h2 className="text-white footerTitle">SUPPORT</h2>
                  <ul className="footer_link">
                    <li>
                      <h3 className='m-0 d-contents'><Link to="/customer-service">Customer Service</Link></h3>
                    </li>
                    <li>
                      <h3 className='m-0 d-contents'><Link to="/customer-service/our-warranty">Warranty</Link></h3>
                    </li>
                    <li>
                      <h3 className='m-0 d-contents'><Link to="/repairs">Repairs</Link></h3>
                    </li>
                    <li>
                      <h3 className='m-0 d-contents'><Link to="/customer-service/returns-exchanges">
                        Returns & Exchanges
                      </Link></h3>
                    </li>
                    <li>
                      <h3 className='m-0 d-contents'><Link to="/customer-service/shipping">Shipping</Link></h3>
                    </li>
                    <li>
                      <h3 className='m-0 d-contents'><Link to="/financing">Financing</Link></h3>
                    </li>
                    <li>
                      <h3 className='m-0 d-contents'><Link to="/customer-service/custom-design-faq">FAQ</Link></h3>
                    </li>
                  </ul>
                </div>
                <div className="footer_box">
                  <h2 className="text-white footerTitle">LEARN</h2>
                  <ul className="footer_link">
                    <li>
                      <h3 className='m-0 d-contents'><Link to="/ring-promise">Perfect Ring Promise</Link></h3>
                    </li>
                    <li>
                      <h3 className='m-0 d-contents'><Link to="/education">Education</Link></h3>
                    </li>
                    <li>
                      <h3 className='m-0 d-contents'><Link to="/our-difference">Our Difference</Link></h3>
                    </li>
                    <li>
                      <h3 className='m-0 d-contents'><Link to="/blog">Blog</Link></h3>
                      {/* <h3 className='m-0 d-contents'><a target='_blank' href="https://www.facet.weddingdaydiamonds.com/">Blog</a></h3> */}
                    </li>
                  </ul>
                </div>
                <div className="footer_box">
                  <h2 className="text-white footerTitle">Connect</h2>
                  <ul className="footer_link">
                    <li>
                      <h3 className='m-0 d-contents'><Link to="/contact-us">Contact Us</Link></h3>
                    </li>
                    <li>
                      <h3 className='m-0 d-contents'><Link
                        to="https://www.instagram.com/weddingdaydiamonds/"
                        target="_blank"
                      >
                        <FaInstagram />
                        Instagram
                      </Link></h3>
                    </li>
                    <li>
                      <h3 className='m-0 d-contents'><Link
                        to="https://www.facebook.com/WeddingDayDiamondsMN/"
                        target="_blank"
                      >
                        <GrFacebookOption />
                        Facebook
                      </Link></h3>
                    </li>
                    <li>
                      <h3 className='m-0 d-contents'>
                        <Link
                          to="https://br.pinterest.com/weddingdaydiamonds/"
                          target="_blank"
                        >
                          <FaPinterestP />
                          Pinterest
                        </Link></h3>
                    </li>
                    <li>
                      <h3 className='m-0 d-contents'><Link
                        to="https://www.tiktok.com/@weddingdaydiamonds"
                        target="_blank"
                      >
                        <FaTiktok />
                        TikTok
                      </Link></h3>
                    </li>
                    {/* <li><Link to='https://www.youtube.com/c/weddingdaydiamonds' target='_blank'>YouTube</Link></li> */}
                  </ul>
                </div>
                <div className="footer_box">
                  <h2 className="text-white footerTitle">Find A Showroom</h2>
                  <ul className="footer_link">
                    <li>
                      <h3 className='m-0 d-contents'><Link to="/showroom">Locations</Link></h3>
                    </li>
                    <li>
                      <h3 className='m-0 d-contents'><Link to="/book-an-appointment">Book an Appointment</Link></h3>
                    </li>
                    <li>
                      <h3 className='m-0 d-contents'><Link to="/virtual-appointment">
                        Virtual Appointment
                      </Link></h3>
                    </li>
                  </ul>
                </div>
                <div className="footer_box footer_link w100On767">
                  <h2 className="text-white footerTitle">Events</h2>
                  <ul className="footer_link">
                    {/* <li>
                      <h3 className='m-0 d-contents'><Link to="/fall-band-event">Fall Band Event</Link></h3>
                    </li>  */}
                    {/* <li><Link to='/spring-band-event'>Band Event</Link></li> */}
                    <li className='mb-4'><Link to='/summer-band-event'>Band Event</Link></li>
                    {/* <li><Link to='/stay-tuned'>Holiday</Link></li> */}
                    {/* <li>
                      <h3 className='m-0 d-contents'><Link to="/fall-band-event">Wedding Band Event</Link></h3>
                    </li> */}
                    {/* <li><h3 className='m-0 d-contents'><Link to='/stay-tuned'>Community</Link></h3></li> */}
                    <li className='mb-3'>
                      <Link className="footer_sublink footerTitle m-0 d-contents" to="/sell-gold-silver-jewelry">Sell Gold & Silver</Link>
                    </li>
                    <li>
                      <Link className="footer_sublink footerTitle m-0 d-contents" style={{ paddingTop: "0px", marginTop: "18px" }} to="/our-team">Join Our Team</Link>
                    </li>
                  </ul>



                </div>
              </div>
            </Col>
            <Col md={6} lg={3} className="p-0">
              <div className="footer-form">
                <div className="footer_box">
                  <h2 className="text-white footerTitle">In the know</h2>
                  <h3 className='dec_inknow'>
                    Sign up for our email list and be in the know for all
                    upcoming events, promotions, new styles + more! Don't worry,
                    you can opt out at anytime.
                  </h3>
                  <Form onSubmit={hndlnewsletter}>
                    <Form.Group className="mb-3" controlId="formBasicText">
                      <Form.Control
                        placeholder="YOUR NAME"
                        type="text"
                        value={newslettername}
                        onChange={(e) => setNewslettername(e.target.value)}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Control
                        placeholder="EMAIL"
                        type="email"
                        value={newsletteremail}
                        onChange={(e) => setNewsletteremail(e.target.value)}
                        required
                      />
                    </Form.Group>

                    <ReCAPTCHA
                      sitekey="6Lc6LUscAAAAAKO2DYPGrIPSnwx3fzROCxJzNWQ0"
                      onChange={capthcaHandle}
                    />
                    <Button className="newsletter_btn" type="submit" disabled={captchaStatus ? true : false}>
                      {
                        loader ? "Sending..." : "SUBMIT"
                      }
                    </Button>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
      <p className="copyright-text mobile_hide pb-4">
        © {new Date().getFullYear()} Wedding Day Diamonds <span>|</span>{' '}
        <Link className='position-relative hoverLine' to="/terms-and-conditions">Terms & Conditions</Link>{' '}
        <span>|</span> <Link className='position-relative hoverLine' to="/privacy-policy">Privacy Policy</Link>{' '}
        <span>|</span> <Link className='position-relative hoverLine' to="/">Accessibilty</Link> <span>|</span>{' '}
        <Link className='hoverLine' to="/">Site Map</Link>
      </p>

      <p className="copyright-text desktop_hide pb-4">
        © {new Date().getFullYear()} Wedding Day Diamonds <br /> <span>|</span>{' '}
        <Link className='position-relative' to="/terms-and-conditions">Terms & Conditions</Link>{' '}
        <span>|</span> <Link className='position-relative' to="/privacy-policy">Privacy Policy</Link>{' '}
        <span>|</span> <Link className='position-relative' to="/">Accessibilty</Link> <span>|</span>{' '}
        <Link className='position-relative' to="/">Site Map</Link>
      </p>

      <IoIosArrowUp
        className="scroll-to-top-btn"
        onClick={scrollToTop}
        style={{ display: visible ? 'inline' : 'none' }}
      />

      <LiveChatWidget
        license="4226431"
        visibility="minimized"
        onNewEvent={handleNewEvent}
      />
      <Container>
        <div className='seo_urlsss'>
          <ul>
            <li><a href="https://wd.demobw.com">https://wd.demobw.com/product-detail/:group_id/:slug</a></li>
            <li><a href="https://wd.demobw.com/special">https://wd.demobw.com/special</a></li>
            <li><a href="https://wd.demobw.com/thank-you/:order_number/:order_id">https://wd.demobw.com/thank-you/:order_number/:order_id</a></li>
            <li><a href="https://wd.demobw.com/person-appointment">https://wd.demobw.com/person-appointment/:location</a></li>
            <li><a href="https://wd.demobw.com/terms-and-conditions">https://wd.demobw.com/terms-and-conditions</a></li>
            <li><a href="https://wd.demobw.com/privacy-policy">https://wd.demobw.com/privacy-policy</a></li>
            <li><a href="https://wd.demobw.com/contact-us">https://wd.demobw.com/contact-us</a></li>
            <li><a href="https://wd.demobw.com/customer-service">https://wd.demobw.com/customer-service</a></li>
            <li><a href="https://wd.demobw.com/stay-tuned">https://wd.demobw.com/stay-tuned</a></li>
            <li><a href="https://wd.demobw.com/summer-band-event">https://wd.demobw.com/summer-band-event</a></li>
            <li><a href="https://wd.demobw.com/wishlist">https://wd.demobw.com/wishlist</a></li>
            <li><a href="https://wd.demobw.com/book-an-appointment">https://wd.demobw.com/book-an-appointment</a></li>
            <li><a href="https://wd.demobw.com/showroom">https://wd.demobw.com/showroom</a></li>
            <li><a href="https://wd.demobw.com/gallery">https://wd.demobw.com/gallery</a></li>
            <li><a href="https://wd.demobw.com/education">https://wd.demobw.com/education</a></li>
            <li><a href="https://wd.demobw.com/custom-design">https://wd.demobw.com/custom-design</a></li>
            <li><a href="https://wd.demobw.com/person-appointment">https://wd.demobw.com/person-appointment</a></li>
            <li><a href="https://wd.demobw.com/virtual-appointment">https://wd.demobw.com/virtual-appointment</a></li>
            <li><a href="https://wd.demobw.com/free-custom-design">https://wd.demobw.com/free-custom-design</a></li>
            <li><a href="https://wd.demobw.com/our-team">https://wd.demobw.com/our-team</a></li>
            <li><a href="https://wd.demobw.com/our-difference">https://wd.demobw.com/our-difference</a></li>
            <li><a href="https://wd.demobw.com/repairs">https://wd.demobw.com/repairs</a></li>
            <li><a href="https://wd.demobw.com/sell-gold-silver-jewelry">https://wd.demobw.com/sell-gold-silver-jewelry</a></li>
            <li><a href="https://wd.demobw.com/jewelry-guides">https://wd.demobw.com/jewelry-guides</a></li>
            <li><a href="https://wd.demobw.com/engagement-rings-buying-guide">https://wd.demobw.com/engagement-rings-buying-guide</a></li>
            <li><a href="https://wd.demobw.com/fashion-Jewelry-guide">https://wd.demobw.com/fashion-Jewelry-guide</a></li>
            <li><a href="https://wd.demobw.com/lab-Grown-diamond-jewelry-guide">https://wd.demobw.com/lab-Grown-diamond-jewelry-guide</a></li>
            <li><a href="https://wd.demobw.com/necklaces-and-pendants-guide">https://wd.demobw.com/necklaces-and-pendants-guide</a></li>
            <li><a href="https://wd.demobw.com/ultimate-bracelet-guide">https://wd.demobw.com/ultimate-bracelet-guide</a></li>
            <li><a href="https://wd.demobw.com/the-ultimate-guide-to-wedding-bands">https://wd.demobw.com/the-ultimate-guide-to-wedding-bands</a></li>
            <li><a href="https://wd.demobw.com/earring-guide">https://wd.demobw.com/earring-guide</a></li>
            <li><a href="https://wd.demobw.com/fashion-ring-guide">https://wd.demobw.com/fashion-ring-guide</a></li>
            <li><a href="https://wd.demobw.com/gabriel-co">https://wd.demobw.com/gabriel-co</a></li>
            <li><a href="https://wd.demobw.com/ring-promise">https://wd.demobw.com/ring-promise</a></li>
            <li><a href="https://wd.demobw.com/fall-band-event">https://wd.demobw.com/fall-band-event</a></li>
            <li><a href="https://wd.demobw.com/blog">https://wd.demobw.com/blog</a></li>
            <li><a href="https://wd.demobw.com/blog/:slug">https://wd.demobw.com/blog/:slug</a></li>
            <li><a href="https://wd.demobw.com/spring-band-event">https://wd.demobw.com/spring-band-event</a></li>
            <li><a href="https://wd.demobw.com/payment-declined">https://wd.demobw.com/payment-declined</a></li>
            <li><a href="https://wd.demobw.com/financing">https://wd.demobw.com/financing</a></li>

            <li><a href="https://wd.demobw.com/showroom">https://wd.demobw.com/showroom/</a></li>
            <li><a href="https://wd.demobw.com/showroom/Burnsville">https://wd.demobw.com/showroom/Burnsville</a></li>
            <li><a href="https://wd.demobw.com/showroom/Richfield">https://wd.demobw.com/showroom/Richfield</a></li>
            <li><a href="https://wd.demobw.com/showroom/Minnetonka">https://wd.demobw.com/showroom/Minnetonka</a></li>
            <li><a href="https://wd.demobw.com/showroom/Eden%20Prairie">https://wd.demobw.com/showroom/Eden%20Prairie</a></li>
            <li><a href="https://wd.demobw.com/showroom/Maple%20Grove">https://wd.demobw.com/showroom/Maple%20Grove</a></li>
            <li><a href="https://wd.demobw.com/showroom/St.%20Cloud">https://wd.demobw.com/showroom/St.%20Cloud</a></li>
            <li><a href="https://wd.demobw.com/showroom/Woodbury">https://wd.demobw.com/showroom/Woodbury</a></li>
            <li><a href="https://wd.demobw.com/showroom/Roseville">https://wd.demobw.com/showroom/Roseville</a></li>
            <li><a href="https://wd.demobw.com/showroom/Rochester">https://wd.demobw.com/showroom/Rochester</a></li>

            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Solitaire">https://wd.demobw.com/productlist/engagement-rings/Solitaire</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Halo">https://wd.demobw.com/productlist/engagement-rings/Halo</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Hidden%20Accent">https://wd.demobw.com/productlist/engagement-rings/Hidden Accent</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Side%20stone">https://wd.demobw.com/productlist/engagement-rings/Side Stone</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Vintage">https://wd.demobw.com/productlist/engagement-rings/Vintage</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Nature">https://wd.demobw.com/productlist/engagement-rings/Nature</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Three%20stone">https://wd.demobw.com/productlist/engagement-rings/Three Stone</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Luxury">https://wd.demobw.com/productlist/engagement-rings/Luxury</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Modern">https://wd.demobw.com/productlist/engagement-rings/Modern</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings">https://wd.demobw.com/productlist/engagement-rings/Shop All</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Round">https://wd.demobw.com/productlist/engagement-rings/Round</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Oval">https://wd.demobw.com/productlist/engagement-rings/Oval</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Pear">https://wd.demobw.com/productlist/engagement-rings/Pear</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Princess">https://wd.demobw.com/productlist/engagement-rings/Princess</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Radiant">https://wd.demobw.com/productlist/engagement-rings/Radiant</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Emerald">https://wd.demobw.com/productlist/engagement-rings/Emerald</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Marquise">https://wd.demobw.com/productlist/engagement-rings/Marquise</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Cushion">https://wd.demobw.com/productlist/engagement-rings/Cushion</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/White">https://wd.demobw.com/productlist/engagement-rings/White Gold</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Yellow">https://wd.demobw.com/productlist/engagement-rings/Yellow Gold</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Rose">https://wd.demobw.com/productlist/engagement-rings/Rose Gold</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Platinum">https://wd.demobw.com/productlist/engagement-rings/Platinum</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/new-arrivals">https://wd.demobw.com/productlist/engagement-rings/New Style</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/best-sellers">https://wd.demobw.com/productlist/engagement-rings/best-sellers</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/best-sellers">https://wd.demobw.com/productlist/engagement-rings/Top Twenty</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Quick-Ship">https://wd.demobw.com/productlist/engagement-rings/Quick Ship</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Tierra%20Collection">https://wd.demobw.com/productlist/engagement-rings/Tierra</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/Atia%20Couture">https://wd.demobw.com/productlist/engagement-rings/Atia%20Couture</a></li>
            <li><a href="https://wd.demobw.com/productlist/engagement-rings/The%20Grand%20Collection">https://wd.demobw.com/productlist/engagement-rings/The Grand</a></li>
            <li><a href="https://wd.demobw.com/gabriel-co#/bridal">https://wd.demobw.com/productlist/engagement-rings/Gabriel & Co</a></li>


            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Diamond">https://wd.demobw.com/productlist/womens-wedding-bands/diamond</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Curved">https://wd.demobw.com/productlist/womens-wedding-bands/curved</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Mixed%20Shape">https://wd.demobw.com/productlist/womens-wedding-bands/mixed-shape</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Eternity">https://wd.demobw.com/productlist/womens-wedding-bands/eternity</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Stackables">https://wd.demobw.com/productlist/womens-wedding-bands/stackables</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Plain">https://wd.demobw.com/productlist/womens-wedding-bands/plain</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/new-arrivals">https://wd.demobw.com/productlist/womens-wedding-bands/new-styles</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Round">https://wd.demobw.com/productlist/womens-wedding-bands/round</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Marquise">https://wd.demobw.com/productlist/womens-wedding-bands/marquise</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Princess">https://wd.demobw.com/productlist/womens-wedding-bands/princess</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Pear">https://wd.demobw.com/productlist/womens-wedding-bands/pear</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Emerald">https://wd.demobw.com/productlist/womens-wedding-bands/emerald</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Oval">https://wd.demobw.com/productlist/womens-wedding-bands/oval</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands">https://wd.demobw.com/productlist/womens-wedding-bands/shop-all</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Plain">https://wd.demobw.com/productlist/womens-wedding-bands/plain</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Tantalum">https://wd.demobw.com/productlist/womens-wedding-bands/tantalum</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Carved">https://wd.demobw.com/productlist/womens-wedding-bands/carved</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Diamond">https://wd.demobw.com/productlist/womens-wedding-bands/diamond</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Alternative">https://wd.demobw.com/productlist/womens-wedding-bands/Alternative</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/LUXE%20Band%20Collection">https://wd.demobw.com/productlist/womens-wedding-bands/luxe-band-collection</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Nature">https://wd.demobw.com/productlist/womens-wedding-bands/nature-inspired</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Mixed%20Shape">https://wd.demobw.com/productlist/womens-wedding-bands/Mixed%20Shape</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/Curved">https://wd.demobw.com/productlist/womens-wedding-bands/curved-bands</a></li>
            <li><a href="https://wd.demobw.com/productlist/womens-wedding-bands/best-sellers">https://wd.demobw.com/productlist/womens-wedding-bands/top-twenty</a></li>

            <li><a href="https://wd.demobw.com/productlist/earrings">https://wd.demobw.com/productlist/earrings</a></li>
            <li><a href="https://wd.demobw.com/productlist/earrings/Stud">https://wd.demobw.com/productlist/earrings/Stud</a></li>
            <li><a href="https://wd.demobw.com/productlist/earrings/Gemstone">https://wd.demobw.com/productlist/earrings/Gemstone</a></li>
            <li><a href="https://wd.demobw.com/productlist/earrings/Silver">https://wd.demobw.com/productlist/earrings/Silver</a></li>
            <li><a href="https://wd.demobw.com/productlist/earrings/Plain%20Metal">https://wd.demobw.com/productlist/earrings/Plain%20Metal</a></li>
            <li><a href="https://wd.demobw.com/productlist/earrings/Hoops">https://wd.demobw.com/productlist/earrings/Hoops</a></li>
            <li><a href="https://wd.demobw.com/productlist/earrings/Fashion%20Earrings">https://wd.demobw.com/productlist/earrings/Fashion%20Earrings</a></li>

            <li><a href="https://wd.demobw.com/productlist/necklaces/">https://wd.demobw.com/productlist/necklaces/</a></li>
            <li><a href="https://wd.demobw.com/productlist/necklaces/Solitaire">https://wd.demobw.com/productlist/necklaces/Solitaire</a></li>
            <li><a href="https://wd.demobw.com/productlist/necklaces/Tennis">https://wd.demobw.com/productlist/necklaces/Tennis</a></li>
            <li><a href="https://wd.demobw.com/productlist/necklaces/Fashion">https://wd.demobw.com/productlist/necklaces/Fashion</a></li>
            <li><a href="https://wd.demobw.com/productlist/necklaces/Gemstone">https://wd.demobw.com/productlist/necklaces/Gemstone</a></li>
            <li><a href="https://wd.demobw.com/productlist/necklaces/Silver">https://wd.demobw.com/productlist/necklaces/Silver</a></li>

            <li><a href="https://wd.demobw.com/productlist/bracelets/">https://wd.demobw.com/productlist/bracelets/</a></li>
            <li><a href="https://wd.demobw.com/productlist/bracelets/Plain%20Metal">https://wd.demobw.com/productlist/bracelets/Plain%20Metal</a></li>
            <li><a href="https://wd.demobw.com/productlist/bracelets/Tennis">https://wd.demobw.com/productlist/bracelets/Tennis</a></li>
            <li><a href="https://wd.demobw.com/productlist/bracelets/Fashion">https://wd.demobw.com/productlist/bracelets/Fashion</a></li>
            <li><a href="https://wd.demobw.com/productlist/bracelets/Gemstone">https://wd.demobw.com/productlist/bracelets/Gemstone</a></li>
            <li><a href="https://wd.demobw.com/productlist/bracelets/Silver">https://wd.demobw.com/productlist/bracelets/Silver</a></li>

            <li><a href="https://wd.demobw.com/productlist/fashion-rings/">https://wd.demobw.com/productlist/fashion-rings/</a></li>
            <li><a href="https://wd.demobw.com/productlist/fashion-rings/Stackables">https://wd.demobw.com/productlist/fashion-rings/Stackables</a></li>
            <li><a href="https://wd.demobw.com/productlist/fashion-rings/Diamond">https://wd.demobw.com/productlist/fashion-rings/Diamond</a></li>
            <li><a href="https://wd.demobw.com/productlist/fashion-rings/Fashion">https://wd.demobw.com/productlist/fashion-rings/Fashion</a></li>
            <li><a href="https://wd.demobw.com/productlist/fashion-rings/Gemstone">https://wd.demobw.com/productlist/fashion-rings/Gemstone</a></li>
            <li><a href="https://wd.demobw.com/productlist/fashion-rings/Mixed%20shape">https://wd.demobw.com/productlist/fashion-rings/Mixed%20shape</a></li>

            <li><a href="https://wd.demobw.com/productlist/fine-jewelry/">https://wd.demobw.com/productlist/fine-jewelry/</a></li>
            <li><a href="https://wd.demobw.com/productlist/fine-jewelry/best-sellers">https://wd.demobw.com/productlist/fine-jewelry/best-sellers</a></li>
            <li><a href="https://wd.demobw.com/productlist/fine-jewelry/Gemstone">https://wd.demobw.com/productlist/fine-jewelry/Gemstone</a></li>
            <li><a href="https://wd.demobw.com/productlist/fine-jewelry/Silver">https://wd.demobw.com/productlist/fine-jewelry/Silver</a></li>
            <li><a href="https://wd.demobw.com/productlist/fine-jewelry/Tennis">https://wd.demobw.com/productlist/fine-jewelry/Tennis</a></li>
            <li><a href="https://wd.demobw.com/productlist/fine-jewelry/Mixed%20shape">https://wd.demobw.com/productlist/fine-jewelry/Mixed%20shape</a></li>
            <li><a href="https://wd.demobw.com/productlist/fine-jewelry/gift-500">https://wd.demobw.com/productlist/fine-jewelry/gift-500</a></li>
            <li><a href="https://wd.demobw.com/productlist/fine-jewelry/gift-250">https://wd.demobw.com/productlist/fine-jewelry/gift-250</a></li>
            <li><a href="https://wd.demobw.com/productlist/fine-jewelry/gift-over-2000">https://wd.demobw.com/productlist/fine-jewelry/gift-over-2000</a></li>


            <li><a href="https://wd.demobw.com/customer-service/">https://wd.demobw.com/customer-service/</a></li>
            <li><a href="https://wd.demobw.com/customer-service/ring-cleaning">https://wd.demobw.com/customer-service/ring-cleaning</a></li>
            <li><a href="https://wd.demobw.com/customer-service/engraving">https://wd.demobw.com/customer-service/engraving</a></li>
            <li><a href="https://wd.demobw.com/customer-service/appraisals">https://wd.demobw.com/customer-service/appraisals</a></li>
            <li><a href="https://wd.demobw.com/customer-service/engraving">https://wd.demobw.com/customer-service/engraving</a></li>
          </ul>
        </div>
      </Container>
    </>
  );
};

export default Footer;
